import { Link, useLocation } from 'react-router-dom'
import { assistAnchor } from '@/features/assist/anchors'
import { workspaceNavigation, isNavigationItemActive } from './navigation'
import MobileNavDrawer from './MobileNavDrawer'

/** Phone task bar occupies its own shell row, so it never covers page actions. */
export default function MobileBottomNav() {
  const { pathname } = useLocation()
  return (
    <nav aria-label="Quick navigation" className="grid shrink-0 grid-cols-5 border-t border-line bg-surface px-1 pb-[env(safe-area-inset-bottom)] md:hidden">
      {workspaceNavigation.map((item) => {
        const active = isNavigationItemActive(pathname, item)
        const Icon = item.icon
        return (
          <Link key={item.path} to={item.path} {...assistAnchor(item.assist)} aria-current={active ? 'page' : undefined}
            className={`my-1 flex min-h-14 min-w-0 flex-col items-center justify-center gap-1 rounded-control px-0.5 text-[11px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand ${active ? 'bg-brand-subtle text-brand-ink' : 'text-ink-2 hover:bg-surface-2 hover:text-ink'}`}>
            <Icon className="size-5" aria-hidden="true" />
            <span>{item.label}</span>
          </Link>
        )
      })}
      <MobileNavDrawer bottomBar active={!workspaceNavigation.some((item) => isNavigationItemActive(pathname, item))} />
    </nav>
  )
}
